import { Box, SxProps, useTheme } from "@mui/material";

interface FieldWrapperProps {
  children: React.ReactNode;
  sx?: SxProps;
}

const FieldWrapper = ({ children, sx }: FieldWrapperProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{ p: theme.nawy.spacing.md, width: "100%", minWidth: "350px", ...sx }}
    >
      {children}
    </Box>
  );
};

export default FieldWrapper;
